module.exports = __webpack_public_path__ + "img/order_status_fahuo@2x.1e16dcf1.png";